// extracted by mini-css-extract-plugin
export default {"sponsoredBanner":"kY-z","sponsoredTooltipWrapper":"lY-z","sponsoredTooltip":"mY-z","newCard":"nY-z"};